import React from 'react';
import {IconProps} from "./RightDropdownArrow";

const RightProductArrow = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="16"
			viewBox="0 0 20 16"
			fill="none"
			className="right-product-arrow"
		>
			<path
				d="M19.6134 8.70711C20.0039 8.31658 20.0039 7.68342 19.6134 7.29289L13.2494 0.928932C12.8589 0.538408 12.2257 0.538408 11.8352 0.928932C11.4447 1.31946 11.4447 1.95262 11.8352 2.34315L17.492 8L11.8352 13.6569C11.4447 14.0474 11.4447 14.6805 11.8352 15.0711C12.2257 15.4616 12.8589 15.4616 13.2494 15.0711L19.6134 8.70711ZM0.90625 9H18.9062V7H0.90625V9Z"
				fill={props.color}
			/>
		</svg>
	);
};

export default RightProductArrow;